import { gql } from '@apollo/client';
import { getQueryParams } from '../../../../utils';

const buildRelationSearchQuery = schema =>
  gql`
    query getRelationsSearch($where: JSON, $offset: Int, $limit: Int) {
      searchData: ${schema.actions.getAll}(where: $where, offset: $offset, limit: $limit) {
        ${getQueryParams(schema.displayProperties)}
      }
    }
  `;

export default buildRelationSearchQuery;
